import React from "react"
import Overview from "../overview"
import moment from "moment";
import { getContactList } from "relay/campaigns"
import CampaignFilterBar from "./campaignFilterBar"
import { getCampaignsByPropertyIdsSelected } from "../utils"
import EmptyViewContact from "images/EmptyViewContact.svg"
import { compare } from "content/utils/commonParsing"
import { getDate } from "content/utils/commonParsing";
import Loading from "storybookComponents/Loader"
import EmptyView from "../Components/NoPropView"
import TableHeader from "../Components/tableHeader"
import StyledTable from 'components/TableComponent';
import {
  csvHeadersContacts,
  getContactRows,
  getColumnsForContact,
  getData
} from "../common"


const tableFilterOption = [
  {
    id: "All",
    label: "All",
  },
  {
    id: "Yes",
    label: "Yes",
  },
  {
    id: "No",
    label: "No",
  },
];


const tableReferredOption = [
  {
    id: "all",
    label: "All",
  },
  {
    id: "referred",
    label: "Referred",
  },
  {
    id: "not_referred",
    label: "Not Referred",
  },
];


const SingleCampaign = ({ subMenu, subOrgDetails, propertiesOfOrg, allCampaignsByProperties, selectedCampaign, classes, setReportData, previewReport }) => {

  const [monthRange, setMonthRange] = React.useState(selectedCampaign.monthRange || { startAt: moment().startOf("month"), endAt: moment().endOf("month"), label: "This Month" })
  const [selectedProperties, setSelectedProperties] = React.useState([selectedCampaign.propertyId]);
  const [selectedCampaigns, setSelectedCampaigns] = React.useState([selectedCampaign.id]);
  const [campaignsForDropDown, setCampaignsForDropDown] = React.useState([]);
  const [status, setStatus] = React.useState(selectedCampaign.status || ['all'])
  const [rows, setRows] = React.useState(null);
  const [csvData, setCsvData] = React.useState([])
  const [data, setData] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [showFilter, setShowFilter] = React.useState(false);
  const [defaultSelectedCampaign, setDefaultSelectedCampaign] = React.useState(selectedCampaign)

  React.useEffect(() => {
    if (previewReport) {
      let params = JSON.parse(previewReport.params)
      let propertiesParams = params.property_ids || [subOrgDetails.id];
      let campaignsParams = params.campaigns_id || [];
      let referredParams = [params.referred_status]
      let monthRangeParams = { startAt: moment().startOf("month"), endAt: moment().endOf("month"), label: "This Month" }
      if (params.start_date && params.end_date && params.range_label) {
        monthRangeParams = { startAt: moment(params.start_date).startOf("month"), endAt: moment(params.end_date).endOf("month"), label: params.range_label }
      }
      setStatus(referredParams)
      setSelectedProperties(propertiesParams);
      setSelectedCampaigns(campaignsParams)
      setMonthRange(monthRangeParams);
      let list = getCampaignsByPropertyIdsSelected(propertiesParams, allCampaignsByProperties)[0].list
      setCampaignsForDropDown(list);
      let defaultSelected = list.find(e => e.id == campaignsParams[0]);
      getContactListData(campaignsParams, referredParams[0], monthRangeParams, defaultSelected)

    } else {
      let campaignId;
      let list = getCampaignsByPropertyIdsSelected([selectedCampaign.propertyId], allCampaignsByProperties)[0].list
      setCampaignsForDropDown(list);
      if (selectedCampaign.id) {
        campaignId = selectedCampaign.id;
      } else {
        campaignId = list[0].id;
        setDefaultSelectedCampaign(list[0])
        setSelectedCampaigns([campaignId])
      }
      if (selectedCampaign.id) {
        getContactListData([campaignId], status[0], monthRange)
      } else {
        getContactListData([campaignId], status[0], monthRange, list[0])
      }
    }

  }, [1])

  console.log("defaultSelectedCampaign", defaultSelectedCampaign)

  const getContactListData = async (campaignIds, referred, monthRange, selectedCampaign) => {
    setLoading(true)
    try {
      const response = await getContactList(
        subOrgDetails.org.id,
        campaignIds,
        "",
        referred,
        monthRange.startAt,
        monthRange.endAt
      );
      if (response.contactList) {
        setDefaultSelectedCampaign(response.contactList.length > 0 ? response.contactList[0] : selectedCampaign ? {
          ...selectedCampaign,
          friendsCount: "0",
          residentsCount: "0",
          leasedCount: "0"
        } : {
            ...defaultSelectedCampaign,
            friendsCount: "0",
            residentsCount: "0",
            leasedCount: "0"
          })
        setRows(getContactRows(response.contactList, classes))
        setCsvData(getData(response.contactList));
        setData(response.contactList);
        let _label = monthRange.label;
        if (monthRange.label === "Custom Range") {
          let start = moment(monthRange.startAt).format("D MMM YYYY");
          let end = moment(monthRange.endAt).format("D MMM YYYY");
          _label = start + " - " + end;
          if (start === end) {
            _label = start;
          }
        }

        setReportData({
          tabName: "Campaign Analytics",
          params: JSON.stringify({
            property_ids: selectedProperties,
            range_label: _label,
            report_type: "hyRaf_system_dashboard",
            start_date: moment(monthRange.startAt).format("YYYY/MM/DD"),
            end_date: moment(monthRange.endAt).format("YYYY/MM/DD"),
            org_id: subOrgDetails.org.id,
            referred_status: referred,
            campaigns_id: campaignIds
          }),
          type: "hyRaf_system_dashboard",
          month: _label
        })
        setLoading(false)
      }
    } catch (err) {
      console.log("Err", err)
    }
  }

  const handleSort = (field, order) => {
    let sortedData = data.slice().sort((a, b) => compare(a[field], b[field], !order))
    setRows(getContactRows(sortedData, classes));
    setCsvData(getData(sortedData));
  }


  const handleChangeProperty = (selected) => {
    setSelectedProperties(selected)
    setSelectedCampaigns([])
    setCampaignsForDropDown(getCampaignsByPropertyIdsSelected(selected, allCampaignsByProperties)[0].list);
  }

  const handleMonthRange = (time) => {
    setMonthRange(time);
    getContactListData(selectedCampaigns, status[0], time)
  }

  const handleChangeCampaigns = (selected) => {
    setSelectedCampaigns(selected)
    getContactListData(selected, status[0], monthRange)
  }

  const handleStatusChange = (values) => {
    setStatus(values)
    getContactListData(selectedCampaigns, values[0], monthRange)
  }

  const handleShowFilter = () => {
    setShowFilter(!showFilter)
  }

  const handleFilterProperty = (f, key) => {
    if (f) {
      let filteredData = data.slice().filter(item => {
        if (item[key]) {
          return item[key].toLowerCase().includes(f.toLowerCase())
        }
      })
      setRows(getContactRows(filteredData, classes))
      setCsvData(getData(filteredData))
    } else {
      setRows(getContactRows(data, classes))
      setCsvData(getData(data));
    }
  }

  const handleFilter = (filterValue) => {
    if (filterValue && filterValue.id !== "All") {
      let filteredData = data.filter(e => e.leased === (filterValue.id === "Yes" ? true : false))
      setCsvData(getData(filteredData))
      setRows(getContactRows(filteredData, classes))
    } else {
      setCsvData(getData(data))
      setRows(getContactRows(data, classes))
    }
  }


  const handleReferredFilter = (filterValue) => {
    if (filterValue && filterValue.id !== "all") {
      let filteredData = data.filter(e => e.referredStatus == (filterValue.id === "referred" ? true : false))
      setCsvData(getData(filteredData))
      setRows(getContactRows(filteredData, classes))
    } else {
      setCsvData(getData(data))
      setRows(getContactRows(data, classes))
    }
  }



  const handleDateFilter = (e) => {
    handleFilterProperty(getDate(e), "leasedDate")
  }

  return (
    <div>
      <CampaignFilterBar
        propertiesOfOrg={propertiesOfOrg}
        selectedProperties={selectedProperties}
        selectedCampaigns={selectedCampaigns}
        campaignsForDropDown={campaignsForDropDown}
        monthRange={monthRange}
        subOrgDetails={subOrgDetails}
        handleChangeProperty={handleChangeProperty}
        handleMonthRange={handleMonthRange}
        handleChangeCampaigns={handleChangeCampaigns}
        classes={classes}
        status={status}
        handleStatusChange={handleStatusChange}
      />
      <div>
        {loading ? <Loading /> :
          <>
            <Overview
              monthRange={monthRange}
              orgId={subOrgDetails.org.id}
              subMenu={subMenu}
              defaultSelectedCampaign={defaultSelectedCampaign}
              headerText={`Campaign Overview - ${defaultSelectedCampaign.campaignName || defaultSelectedCampaign.value || defaultSelectedCampaign.title}`}
            />
            <div className={classes.bottomView}>
              {
                (data.length == 0) ? <EmptyView message="No contact to show up for the selected filters." image={EmptyViewContact} /> :
                  <div>
                    <TableHeader
                      title={`Drill Down - Campaign (${data.length})`}
                      csvData={csvData}
                      csvHeaders={csvHeadersContacts.slice(2)}
                      fileName="Breakdown Properties(22).csv"
                      showFilter={showFilter}
                      handleShowFilter={handleShowFilter}
                    />
                    <StyledTable
                      columns={getColumnsForContact(classes, handleFilterProperty, handleDateFilter, tableFilterOption[0], handleFilter, tableFilterOption, tableReferredOption, tableReferredOption[0], handleReferredFilter).slice(2)}
                      rows={rows}
                      sortHandler={handleSort}
                      className={classes.tableContainerRoot}
                      defaultSortBy="resident"
                      showFilter={showFilter}
                    />
                  </div>
              }
            </div>
          </>
        }
      </div>
    </div>

  )
}

export default SingleCampaign